import React from "react";
import Chart from "react-apexcharts";

const ReportsChart = () => {
  const chartOptions = {
    chart: {
      height: 350,
      type: "line",
      zoom: { enabled: true },
    },
    dataLabels: { enabled: false },
    stroke: { curve: "straight" },
    title: {
      text: "Product Trends by Month",
      align: "left",
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"], // Repeating colors
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    },
  };

  const seriesData = [
    {
      name: "Desktops",
      data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
    },
  ];

  return (
    <div style={{ minHeight: "400px"  }}>
      <Chart options={chartOptions} series={seriesData} type="line" height={350} />
    </div>
  );
};

export default ReportsChart;
